<ion-content>
  <div class="error">
    <ion-icon class="error__icon" name="warning"></ion-icon>
    <h1 class="error__text">
      {{ "MAINTENANCE.MAINTENANCE_TITLE" | translate }}
    </h1>
    <h2 class="error__text">
      {{ "MAINTENANCE.MAINTENANCE_SUBTITLE" | translate }}
    </h2>
  </div>
</ion-content>
